export type PublicPage = 'landing' | 'blog' | 'tools' | 'shop' | 'pricing' | 'connect' | 'forgot-password' | 'reset-password';
export type UrlRoute =
  | { group: 'share'; page: 'content' | 'win' | 'stats'; token: string }
  | { group: 'public'; page: PublicPage; detail: string | null }
  | { group: 'device'; path: string }
  | { group: 'workspace'; path: string };

/** One URL classifier for initial boot, history changes, and legacy hash links.
 * Stateful workout navigation remains in App; it must not remount a session.
 */
export function classifyUrl(pathname: string, hash = ''): UrlRoute {
  const path = (hash.startsWith('#/share/') || hash === '#/connect')
    ? hash.slice(1) : pathname;
  if (['/meta', '/g', '/display', '/glasses', '/glasses-login', '/pair', '/store'].includes(path)) {
    return { group: 'device', path };
  }
  const share = path.match(/^\/share\/(content|win|stats)\/([^/?#]+)\/?$/);
  if (share) {
    let token = share[2];
    try { token = decodeURIComponent(token); } catch { /* preserve opaque malformed input for the API error */ }
    return { group: 'share', page: share[1] as 'content' | 'win' | 'stats', token };
  }
  if (path === '/') return { group: 'public', page: 'landing', detail: null };
  for (const page of ['blog', 'tools'] as const) {
    if (path === `/${page}` || path.startsWith(`/${page}/`)) {
      return { group: 'public', page, detail: path.slice(page.length + 2) || null };
    }
  }
  if (path === '/shop' || path === '/shop/compare' || path.startsWith('/shop/compare/')) {
    return { group: 'public', page: 'shop', detail: path.slice('/shop/compare/'.length) || null };
  }
  for (const page of ['pricing', 'connect', 'forgot-password', 'reset-password'] as const) {
    if (path === `/${page}`) return { group: 'public', page, detail: null };
  }
  // Preserve legacy callbacks, imports, messages, pairing and lens aliases.
  return { group: 'workspace', path: pathname };
}